import {React, useState} from "react";
import { Navbar } from "react-bootstrap";
import { Link } from "react-router-dom";
import classes from "./Header.module.css";

const Header = () => {
  
  const [show, setShow] = useState(false);
  const showNavigation = () => {
    setShow(true)
  }

  const removeNavigation = () => {
    setShow(false);
  }

  let navClassName = classes.navigation;
  let hamburgerClassName = classes.hamburger

  if(show) {
    navClassName += ` ${classes.active}`
    hamburgerClassName += ` ${classes.active}`
  }
  return (
    <header className={`${classes.header} d-flex justify-content-between fixed-top px-3 py-2`} >
      <Link to="/">
        <img
          src="/images/logo.jpg"
          alt="logo"
          className={`rounded-pill ${classes.logo}`}
        />
      </Link>
      <Navbar className={navClassName}>
        <Link to="/" className={`nav-link ${classes.nav_item}`} onClick={removeNavigation}>
          Home
        </Link>
        <Link to="/about" className={`nav-link ${classes.nav_item}`} onClick={removeNavigation}>
          About
        </Link>
        <Link to="/skill" className={`nav-link ${classes.nav_item}`} onClick={removeNavigation}>
          Skill
        </Link>
        <Link to="/projects" className={`nav-link ${classes.nav_item}`} onClick={removeNavigation}>
          Projects
        </Link>
        <Link to="/contact" className={`nav-link ${classes.nav_item}`} onClick={removeNavigation}>
          Contact
        </Link>
      </Navbar>
      {/* <Link to='/JOSHUA_MOSES_Resume.pdf' className={classes.resume} download target="_blank">Resume</Link> */}
      {show ? (<div className={hamburgerClassName} onClick={removeNavigation}>
        <span className={classes.bar}></span>
        <span className={classes.bar}></span>
        <span className={classes.bar}></span>
      </div>) : (<div className={classes.hamburger} onClick={showNavigation}>
        <span className={classes.bar}></span>
        <span className={classes.bar}></span>
        <span className={classes.bar}></span>
      </div>)}
      
    </header>
    
  );
};

export default Header;
